import axios from 'axios'
import {ParamsModel} from 'src/app/modules/common/Model'
import { GeneralApplicationModel } from '../Model'
const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

export const GENERAL_APPLICATION = `${API_URL}/apply-general-clipping`
export const GENERAL_APPLICATION_FILE = `${API_URL}/apply-general-clipping/export`


export const service = {
  getGeneralApplicationsList: (params: ParamsModel) => {
    return axios.get(GENERAL_APPLICATION, {params})
  },

  updateGeneralApplicationsList: (body: GeneralApplicationModel, id: string) => {
    return axios.put(`${GENERAL_APPLICATION}/${id}`, body)
  },

  deleteGeneralApplicationsList: (data: GeneralApplicationModel) => {
    return axios.delete(GENERAL_APPLICATION, {data})
  },

   //Get file
   getGeneralApplicationFile: (fileName: string) => {
    return axios.get(`${GENERAL_APPLICATION_FILE}/${fileName}`).then((response) => {
      const url = response?.data?.data?.file
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `Gold_Rate.${fileName}`) //or any other extension
      document.body.appendChild(link)
      link.click()
    })
  },
}
